import { createFileRoute } from '@tanstack/react-router'

import { RecentlyDeletedAssetsPage } from '@/pages/data-assets/RecentlyDeletedAssets.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/data-assets/recently-deleted',
)({
  component: RecentlyDeletedAssetsPage,
  loader: () => ({
    breadcrumbTitle: 'Recently deleted',
    breadcrumbClassName: 'max-w-40',
  }),
})
